// import logo from "assets/images/logo.svg"
import logo from "assets/images/logo.png"
// import images
import profile from "assets/images/profile-img.png"
import { useFormik } from "formik"
import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
//redux
import { useDispatch, useSelector } from "react-redux"
import { Link, withRouter } from "react-router-dom"
// import jwt_decode from "jwt-decode"
import { emailDomains } from "../../common/data/settings"

import {
  Alert,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormFeedback,
  Input,
  Label,
  Row,
  UncontrolledTooltip,
} from "reactstrap"
// Formik validation
import * as Yup from "yup"
// actions
import {
  LoginUser,
  socialLogin,
  apiError,
  redirect_login,
} from "../../store/actions"
import { handleSSOLogin } from "./SSOLoginUtils"

const Login = props => {
  //meta title
  document.title = "Login | TenderSoftware - Flexi TracBoard"

  const dispatch = useDispatch()

  const [passwordShown, setPasswordShown] = useState(false)

  const [loginState, setLoginState] = useState({
    isAuthenticated: false,
    user: {},
    error: null,
  })

  const searchParams = new URLSearchParams(window.location.search)

  const token = searchParams.get("authToken")
  const userid = searchParams.get("userId")
  
  useEffect(() => {
    const checkExistingAuth = () => {
      const authUser = localStorage.getItem("authUser")
      if (authUser) {
        try {
          const parsedAuth = JSON.parse(authUser)
          if (parsedAuth?.data) {
            const CategoryUser = parsedAuth?.data?.accessgroupname === "CategoryUser"
            if (CategoryUser) {
              props.history.push("/client/viewhours")
            } else {
              props.history.push("/verifyscreen")
            }
            return
          }
        } catch (error) {
          localStorage.removeItem("authUser")
        }
      }
    }

    if (userid && token) {
      localStorage.setItem("token", token)
      localStorage.setItem("userid", userid)
      if (localStorage.getItem("userid") != null) {
        dispatch(redirect_login(userid, props.history))
      }
    } else {
      checkExistingAuth()
      if (process.env.NODE_ENV === 'development') {
        console.log("No URL params - normal login flow")
      }
    }
  }, [userid, token, props.history, dispatch])

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      // email: Yup.string().required("Please Enter Your Email"),
      email: Yup.string()
        .email("Enter valid Email address")
        .max(255)
        .required("Please Enter Your Email"),
      password: Yup.string()
        .required("Please Enter Your Password")
        .min(6, "Password must be at least 6 characters"),
    }),
    onSubmit: values => {
      handleLogin(values)
    },
  })
  const [showSuggestions, setShowSuggestions] = useState(false)

  // Handle input changes
  const handleEmailChange = event => {
    const inputValue = event.target.value
    validation.handleChange(event)
    // Check if the "@" symbol is present and show suggestions
    setShowSuggestions(inputValue.includes("@"))
    // You can further filter email domains based on the input if needed
  }
  useEffect(() => {
    if (showSuggestions) {
      validation.setFieldValue(
        "email",
        `${validation.values.email}${emailDomains}`
      )
    }
  }, [showSuggestions])

  useEffect(() => {
    dispatch(apiError(""))
  }, [])

  const { error } = useSelector(state => ({
    error: state.Login.error,
  }))

  const handleLogin = async values => {
    if (process.env.NODE_ENV === 'development') {
      console.log("🚀 handleLogin called with values:", values)
    }
    var data = {
      username: values?.email,
      password: values?.password,
      Platform: "web",
    }
    if (process.env.NODE_ENV === 'development') {
      console.log("🚀 Dispatching LoginUser with data:", data)
    }
    dispatch(LoginUser(data, props.history))
  }

  // Microsoft SSO Login
  const handleMicrosoftLogin = () => {
    handleSSOLogin(loginState, setLoginState, dispatchSSOUserProfiletoAPI)
  }

  const dispatchSSOUserProfiletoAPI = data => {
    dispatch(socialLogin(data, props.history))
  }
  const togglePassword = () => {
    setPasswordShown(!passwordShown)
  }
  const handleKeyDown = e => {
    // Prevent the default action for the space key (key code 32)
    if (e.keyCode === 32) {
      e.preventDefault()
    }
  }
  return (
    <React.Fragment>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-primary bg-soft">
                  <Row>
                    <Col xs={7} className="padd-right-0">
                      <div className="text-primary p-4 padd-right-0">
                        <h5 className="text-primary">Welcome Back ! </h5>
                        <p>Sign in to continue to FlexiTracBoard.</p>
                      </div>
                    </Col>
                    <Col className="col-5 align-self-end">
                      <img src={profile} alt="" className="img-fluid" />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div>
                    <Link to="/" className="auth-logo-light">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src={logo}
                            alt=""
                            className="rounded-circle"
                            height="34"
                          />
                        </span>
                      </div>
                    </Link>
                  </div>
                  <div className="p-2">
                    <Form
                      className="form-horizontal"
                      onSubmit={e => {
                        e.preventDefault()
                        validation.handleSubmit()
                        return false
                      }}
                    >
                      {error?.statusCode === 0 ? null : error ? (
                        <Alert color="danger">
                          {error?.response?.data?.message}
                        </Alert>
                      ) : null}

                      <div className="mb-3">
                        <Label className="form-label">Email</Label>
                        <Input
                          name="email"
                          type="text"
                          placeholder="Enter Email"
                          // onChange={validation.handleChange}
                          autoComplete="off"
                          onChange={handleEmailChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.email || ""}
                          invalid={
                            validation.touched.email && validation.errors.email
                              ? true
                              : false
                          }
                          onKeyDown={handleKeyDown}
                        />
                        {validation.touched.email && validation.errors.email ? (
                          <FormFeedback type="invalid">
                            {validation.errors.email}
                          </FormFeedback>
                        ) : null}
                      </div>

                      <div className="mb-3">
                        <Label className="form-label">Password</Label>

                        <div className="" style={{ position: "relative" }}>
                          <Input
                            name="password"
                            value={validation.values.password || ""}
                            type={passwordShown ? "text" : "password"}
                            placeholder="Enter Password"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            invalid={
                              validation.touched.password &&
                              validation.errors.password
                                ? true
                                : false
                            }
                          />
                          {validation.touched.password &&
                          validation.errors.password ? (
                            <FormFeedback type="invalid">
                              {validation.errors.password}
                            </FormFeedback>
                          ) : null}
                          {validation.touched.password &&
                          validation.errors.password ? (
                            <i
                              className={
                                passwordShown
                                  ? "align-eye-password fa fa-eye"
                                  : "fa fa-eye-slash align-eye-password"
                              }
                              onClick={e => {
                                togglePassword(e)
                              }}
                              style={
                                validation.touched && validation.errors
                                  ? {
                                      color: "orange",
                                      position: "absolute",
                                      right: "13%",
                                      transform: "translateY(-50%)",
                                      top: "19px",
                                      cursor: "pointer",
                                    }
                                  : {
                                      color: "orange",
                                      position: "absolute",
                                      right: "13%",
                                      transform: "translateY(-50%)",
                                      top: "32%",
                                      cursor: "pointer",
                                    }
                              }
                            />
                          ) : (
                            <i
                              className={
                                passwordShown
                                  ? "align-eye-password fa fa-eye"
                                  : "fa fa-eye-slash align-eye-password"
                              }
                              onClick={e => {
                                togglePassword(e)
                              }}
                              style={
                                validation.touched && validation.errors
                                  ? {
                                      color: "orange",
                                      position: "absolute",
                                      right: "10px",
                                      transform: "translateY(-50%)",
                                      top: "19px",
                                      cursor: "pointer",
                                    }
                                  : {
                                      color: "orange",
                                      position: "absolute",
                                      right: "13%",
                                      transform: "translateY(-50%)",
                                      top: "32%",
                                      cursor: "pointer",
                                    }
                              }
                            />
                          )}
                        </div>
                      </div>

                      <div className="form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="customControlInline"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="customControlInline"
                        >
                          Remember me
                        </label>
                      </div>

                      <div className="mt-3 d-grid">
                        <button
                          className="btn btn-primary btn-block"
                          type="submit"
                        >
                          Log In
                        </button>
                      </div>

                      <div className="mt-4 text-center">
                        <h5 className="font-size-14 mb-3">Sign in with</h5>

                        <ul className="list-inline">
                          <li className="list-inline-item">
                            <div className="social-source text-center mt-3">
                              <div
                                className="avatar-sm mx-auto mb-3"
                                style={{ cursor: "pointer" }}
                                onClick={handleMicrosoftLogin}
                              >
                                <span
                                  className={
                                    "avatar-title rounded-circle bg-primary ms-office-logo"
                                  }
                                >
                                  <i
                                    className={
                                      "mdi mdi-microsoft-office text-white"
                                    }
                                    id="office365"
                                  />

                                  <UncontrolledTooltip
                                    placement="top"
                                    target="office365"
                                    className="text-white"
                                  >
                                    MS Office 365
                                  </UncontrolledTooltip>

                                  {/* className={
                                      "mdi microsoft-windows text-white"
                                    } */}
                                </span>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>

                      <div className="mt-4 text-center">
                        <Link to="/forgot-password" className="text-muted">
                          <i className="mdi mdi-lock me-1" />
                          Forgot your password?
                        </Link>
                      </div>
                    </Form>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p>
                  Don&#39;t have an account ?{" "}
                  <Link to="/register" className="fw-medium text-primary">
                    {" "}
                    Signup now{" "}
                  </Link>{" "}
                </p>
                <p>© {new Date().getFullYear()} TenderSoftware.</p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(Login)

Login.propTypes = {
  history: PropTypes.object,
}
